import { DataService } from "@/services/data";
import { handle_error } from "@/utils/wretch";
import { RouteObject, defer, json } from "react-router-dom";

const RegistrationRoute: RouteObject = {
    path: "inscriptions",
    children: [
        {
            index: true,
            async lazy() {
                let { ListPage } = await import("@/pages/medrep/contacts/registrations");
                return { Component: ListPage };
            },
            loader: async ({ request }) => {
                const url = new URL(request.url);
                if (!url.searchParams.has("page_size")) {
                    url.searchParams.set("page_size", "25");
                }
                const registrations = DataService.client
                    .url(`/medrep/registrations/${url.searchParams ? "?" + url.searchParams.toString() : ""}`)
                    .get()
                    .json();
                return defer({ registrations });
            }
        },
        {
            path: ":registrationId",
            loader: async ({ params }) => {
                const registrationId = params.registrationId;
                const registration = await DataService.client.url(`/medrep/registrations/${registrationId}/`).get().json();
                return registration;
            },
            action: async ({ params, request }) => {
                const registrationId = params.registrationId;
                const data = await request.json();
                const url = new URL(request.url);
                const action = url.searchParams.get("action");
                if (action) {
                    try {
                        const content = await DataService.client.url(`/medrep/registrations/${registrationId}/${action}/`).post(data).json();
                        return json({ success: true, content: content });
                    } catch (error) {
                        return handle_error(error);
                    }
                } else {
                    try {
                        const content = await DataService.client.url(`/medrep/registrations/${registrationId}/`).patch(data).json();
                        return json({ success: true, content: content });
                    } catch (error) {
                        return handle_error(error);
                    }
                }
            }
        },
        {
            path: "export_csv",
            action: async ({ request }) => {
                const data = await request.json();
                try {
                    const content = await DataService.client.url(`/medrep/registrations/export_csv/`).post(data).json();
                    return json({ success: true, content: content });
                } catch (error) {
                    return handle_error(error);
                }
            }
        }
    ]
};

export default RegistrationRoute;
